import { Type } from "@sinclair/typebox";

import { PROJECT_ROLES } from "../roles.js";

import type { TUnion, TSchema } from "@sinclair/typebox";

const Nullable = <G extends TSchema>(T: G): TUnion<TSchema[]> =>
  Type.Union([T, Type.Null()]);

export const CredentialsSchema = Type.Object({
  username: Type.String(),
  password: Type.String(),
});

export const ConfirmPasswordRequestSchema = Type.Object({
  userId: Type.String(),
  verificationCode: Type.String(),
  password: Type.String(),
});

export const PasswordComplexitySchema = Type.Object({
  minLength: Type.Number(),
  hasUppercase: Type.Boolean(),
  hasLowercase: Type.Boolean(),
  hasNumber: Type.Boolean(),
  hasSymbol: Type.Boolean(),
});

export const UserRequestSchema = Type.Object({
  email: Type.String({ format: "email" }),
});

export const UserResponseSchema = Type.Object({
  userId: Type.Optional(Type.String()),
  state: Type.Number(),
  username: Type.String({ format: "email" }),
  type: Type.Union([
    Type.Object({
      case: Type.Literal("human"),
      value: Type.Object({
        userId: Type.String(),
        state: Type.Number(),
        passwordChangeRequired: Type.Boolean(),
        profile: Type.Optional(
          Type.Object({
            givenName: Type.String(),
            familyName: Type.String(),
            displayName: Type.Optional(Type.String()),
          }),
        ),
        email: Type.Optional(
          Type.Object({
            email: Type.String({ format: "email" }),
            isVerified: Type.Boolean(),
          }),
        ),
      }),
    }),
    Type.Object({
      case: Type.Literal("machine"),
      value: Type.Object({
        name: Type.String(),
        description: Type.String(),
      }),
    }),
    Type.Object({
      case: Nullable(Type.String()),
      value: Type.Optional(Nullable(Type.String())),
    }),
  ]),
});

export const RoleKeySchema = Type.Array(
  Type.Union(PROJECT_ROLES.map((role) => Type.Literal(role.key))),
);

export const UserSchema = Type.Object({
  userId: Type.Optional(Type.String()),
  username: Type.String(),
  domain: Type.String({ format: "hostname" }),
  firstName: Type.String(),
  lastName: Type.String(),
  roles: RoleKeySchema,
});

export const ServiceUserSchema = Type.Object({
  userId: Type.Optional(Type.String()),
  username: Type.String(),
  domain: Type.String({ format: "hostname" }),
});

export const VerifyUserRequestSchema = Type.Object({
  userId: Type.String(),
  organizationId: Type.String(),
  verificationCode: Type.String(),
  password: Type.String(),
  hasAcceptedTermsOfService: Type.Boolean(),
});

export const UserIdRequestParamsSchema = Type.Object({
  userId: Type.String(),
});

export const CreateTokenSuccessResponseSchema = Type.Object({
  token: Type.String(),
  expirationDate: Type.String({ format: "date-time" }),
});
